import React, { useEffect, useState } from "react";
import "./DesktopLanding.css";

const DesktopLanding: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Fade in the landing page
    setIsVisible(true);
  }, []);

  return (
    <div className={`desktop-landing ${isVisible ? "visible" : ""}`}>
      <div className="content">
        <h1 className="title">Use app on your mobile</h1>

        {/* QR code using CSS background */}
        <div
          className="qr-code-container"
          role="img"
          aria-label="QR Code"
        ></div>

        <div className="link-container">
          <a
            href="https://t.me/evil_coin_bot"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://t.me/evil_coin_bot
          </a>
        </div>
      </div>
    </div>
  );
};

export default DesktopLanding;
